// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f1ba7901","79":"65bfd9e9","243":"22e498e0","371":"ccbbb53b","511":"03a460e6","786":"d3694c45","915":"450c1750"}[chunkId] + ".chunk.js";
};